import React, { useCallback, useState } from 'react';
import DealerAd from '../..';
import { useWixDealerListener } from '../../DealerAdIframe';
import ddt from '@wix/da-ddt';
import cn from 'classnames';
import Close from '@wix/da-ds/pkg/Icons/16x16/Close';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import s from './Adhesion.scss';
const AdhesionAdUnit = ({ realEstateId })=>{
    const [isVisible, setIsVisible] = useState(false);
    const [isHidden, setIsHidden] = useState(false);
    const isMounted = useIsMounted();
    const handler = useCallback((data)=>{
        ddt.log('dealer', 'Got command from iframe2', data);
        switch(data.command){
            case 'show-adhesion':
                setIsVisible(true);
                break;
            default:
                break;
        }
    }, []);
    useWixDealerListener(realEstateId, handler);
    if (isHidden || !isMounted) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "AdhesionAdUnit"
    }, /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], isVisible && s['visible'])
    }, /*#__PURE__*/ React.createElement(DealerAd, {
        className: s['unit'],
        realEstateId: realEstateId,
        extraParams: process.env.NODE_ENV === 'development' ? {
            forcefixture: 'adhesion',
            newDealerApi: 'y'
        } : {
            newDealerApi: 'y'
        }
    }), /*#__PURE__*/ React.createElement(IconButton, {
        className: s['close'],
        "aria-label": "Hide Advertisment",
        icon: Close,
        size: 'small',
        onClick: ()=>{
            setIsHidden(true);
        }
    })));
};
AdhesionAdUnit.displayName = 'AdhesionAdUnit';
export default AdhesionAdUnit;
